import styled from 'styled-components';
import { SYS_PAGE_MARGIN } from '@oneaudi/unified-web-common';
import { dynamicStylingHelper } from '../../rethink/utils/AlphaHelper';
export const OneCMSLayoutWrapper = styled.div `
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${dynamicStylingHelper(`background-color: #ffffff`)};
  ${(props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return props.useUnifiedLibrary
        ? `  
  position: relative;
  margin: 0 ${SYS_PAGE_MARGIN};`
        : `  
  margin: 0 16px;
  @media (min-width: ${(_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.s}px}) {
    margin: 0 28px;
  }
  @media (min-width:${(_d = (_c = props.theme) === null || _c === void 0 ? void 0 : _c.breakpoints) === null || _d === void 0 ? void 0 : _d.m}px {
    margin: 0 40px;
  }
  @media (min-width: ${(_f = (_e = props.theme) === null || _e === void 0 ? void 0 : _e.breakpoints) === null || _f === void 0 ? void 0 : _f.l}px {
    margin: 0 60px;
  }
  @media (min-width: ${(_h = (_g = props.theme) === null || _g === void 0 ? void 0 : _g.breakpoints) === null || _h === void 0 ? void 0 : _h.xl}px {
    margin: 0 96px;
  }`;
}})
`;
